const standardConstants = {
  ENTERPRISE: 'ENTERPRISE',
  STANDARD: 'STANDARD',
};

export default standardConstants;
